<template>
  <div class="driverStyle">
    <el-form :rules="rules" ref="form" :model="form">
      <div class="halfStyle">
        <div class="title">{{$t('VehicleManagement.baseInform')}}</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="name"
              :label="$t('common.driverName')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.name"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item
              prop="phone"
              :label="$t('VehicleManagement.phone')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.phone"
                autocomplete="off"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="driverNum"
              :label="$t('common.driverNum')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.driverNum"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="card"
              :label="$t('VehicleManagement.card')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.card"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="driverExpires"
              :label="$t('VehicleManagement.driverExpires')"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                disabled
                value-format="yyyy-MM-dd"
                type="date"
                placeholder=""
                v-model="form.driverExpires"
                class="remarkStyle"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="remarks"
              :label="$t('common.remark')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.remarks"
                autocomplete="off"
                class="remarkStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["bindDriver"],
  data() {
    return {
      rules: {},
      form: {
        name: "",
        phone: "",
        driverNum: "",
        card: "",
        driverExpires: "",
        remarks: "",
      },
      formLabelWidth: "108px",
    };
  },
  created() {
   
  },
  methods: {
    getSelectOneDriver() {
      let param = {
        driverNum: this.bindDriver,
      };
      this.$store
        .dispatch("VehicleStatus/GET_SELECTONEDRIVER", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              this.form = {
                name: res.data.data.name,
                phone: res.data.data.phone,
                driverNum: res.data.data.driverNum,
                card: res.data.data.card,
                driverExpires: res.data.data.driverExpires,
                remarks: res.data.data.remarks,
              };
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>